import { render, staticRenderFns } from "./Consent.vue?vue&type=template&id=38db460a&scoped=true&"
import script from "./Consent.vue?vue&type=script&lang=js&"
export * from "./Consent.vue?vue&type=script&lang=js&"
import style0 from "./Consent.vue?vue&type=style&index=0&id=38db460a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38db460a",
  null
  
)

export default component.exports